import React, { useEffect, useState } from 'react'
import { Grid, TextField, Typography, Paper, Button, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogActions } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import DatePicker from 'react-datepicker';
import useRequestResource from '../../hooks/useRequestResource';
import {Search, SearchIconWrapper, StyledInputBase} from '../../components/utils/SearchBar'
import SearchIcon from '@mui/icons-material/Search';
import { FaSortDown, FaSortUp} from "react-icons/fa";

import * as XLSX from 'xlsx'

export default function ActivityLogList() {
    const { getResourceList, resourceList, searchResources, searchList, deleteResource, currentListSize} = useRequestResource({ endpoint: "auth", query: "logs", resourceLabel: "Log List" });
    const { deleteResourcesBefore } = useRequestResource({ endpoint: "auth", query: "log", resourceLabel: "Log"})
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [idToDelete, setIdToDelete] = useState(null);
    const offset = 25
    const [exp, setExp] = useState("")
    const [deleteByDate, handleDeleteByDateChange] = React.useState(null);
    const [sorting_query, setSortingQuery] = useState(null)

    const headerStyle = {
        color: "white",
        backgroundColor: "Green",
        padding: "10px",
        fontFamily: "Arial"
    };

    function onRowClick(e) {
        navigate(`/${e.id}/log`)
    }

    function convertDate(value) {
        let temp = new Date(value) 
        let date = new Date(temp.getTime() - temp.getTimezoneOffset() * 60 * 1000);
        let arr = date.toISOString().split(".")
        return arr[0]
    }

    function changeSort(elem) {
        setSortingQuery(elem)
    }

    function toggleSort(elem) {
        if (sorting_query === elem || sorting_query === `-${elem}`) {
            setSortingQuery(null)
        } else {
            setSortingQuery(elem)
        }
    }

    function onDeleteByDateSubmit() {
        if (deleteByDate == null) {
            return;
        }

        deleteResourcesBefore(convertDate(deleteByDate), () => {
            window.location.reload()
        })
    }

    // On component mount or change in sorting_query
    useEffect(() => {
        if (exp !== "") {
            searchResources(exp, sorting_query)
        } else {
            getResourceList(0, sorting_query)
        }
    }, [sorting_query, getResourceList]);

    const fetchData = () => {
        if (exp == "") {
            getResourceList(offset, sorting_query)
        } else {
            searchResources(exp, sorting_query, offset)
        }
    }

    const fetchAllData = async () => {
        try {
          const path = '/auth/logs/';
          const requestBody = {
            exp: ""
          };
          const response = await fetch(path, 
                {   method: 'PATCH',
                    headers: {'Authorization': `JWT ${localStorage.getItem("accessToken")}`},
                    body: JSON.stringify(requestBody),}
            ).then(res => {
                return res;
            });


          const data = await response.json();
      
          // Process the fetched data as needed
          return data.results; // Return the processed data or perform additional operations
        } catch (error) {
          console.error('Error fetching data:', error);
          throw error; // Rethrow the error to be caught by the caller
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            searchResources(exp, sorting_query);
        }
    };

    const getList = () => {
        if (exp !== "") {
            return searchList.results
        } else {
            return resourceList.results
        }
    }

    const handleDelete = () => {
        setOpen(false);
        onDeleteByDateSubmit(deleteByDate)
    }

    const handleConfirmDelete = () => {
        setOpen(true);
    }

    const handleDeleteClose = () => {
        setOpen(false);
    }

    const handleOnExportView = () => {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(getList());
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, "Log.xlsx");
    }

    const handleOnExportAll = async () => {
        try {
          const data = await fetchAllData();
      
          var wb = XLSX.utils.book_new();
          var ws = XLSX.utils.json_to_sheet(data);
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
          XLSX.writeFile(wb, "Log.xlsx");
        } catch (error) {
          console.error("Error exporting data:", error);
        }
    };

    return (
        <div>
            <Dialog open={open} onClose={handleDeleteClose}>
                <DialogTitle>
                    Are you sure you want to delete this??
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleDelete}>
                        YES
                    </Button>
                    <Button onClick={handleDeleteClose}>
                        NO
                    </Button>
                </DialogActions>
            </Dialog>


            <div style={{ height: "20px" }} />

            <TableContainer component={Paper}>
                <h3 style={headerStyle}>
                    Activity Log
                </h3>

                <Button 
                    onClick={handleOnExportView}
                    size="medium"
                    variant="contained"
                    sx={{ mr: 2 }}> 
                    Export View
                </Button>

                <Button 
                    onClick={handleOnExportAll}
                    size="medium"
                    variant="contained"
                    sx={{ mr: 2 }}> 
                    Export All
                </Button>

                <div style={{ height: "20px" }} />

                <Grid item xs={12} style={{ display: 'flex' }}>

                    <div style={{ display: 'flex'}}>
                        <DatePicker
                                placeholderText='Delete Before'
                                selected={ deleteByDate }
                                onChange={ handleDeleteByDateChange }
                                name="startDate"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={20}
                                timeCaption="time"
                                dateFormat="MMMM d, yyyy h:mm aa"
                                autoComplete='off'
                            >    
                        </DatePicker>
                        <Button 
                                onClick={ handleConfirmDelete }
                                size="small"
                                variant="contained"
                            >
                                Delete
                        </Button>
                    </div>
                </Grid>
        
                <div style={{ height: "20px" }} />

                <Grid item xs={12} >
                    <Search fullWidth>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                            fullWidth
                            id="log"
                            label="Log"
                            value={exp}
                            onChange={(e) => setExp(e.target.value)}
                            onKeyDown={handleKeyDown}
                        />
                    </Search>
                </Grid>

                <div style={{ height: "20px" }} />
                
                <Table sx={{ minWidth: 360 }} size="small">
                    <TableHead width="100%">
                        <TableRow>
                            
                            <TableCell align="center" width="15%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("user__username")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>User</div><div>{sorting_query === "user__username" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-user__username")}></FaSortUp> : 
                                    sorting_query === "-user__username" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("user__username")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="15%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("method")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Action</div><div>{sorting_query === "method" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-method")}></FaSortUp> : 
                                    sorting_query === "-method" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("method")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="15%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("date_and_time")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Date of Activity</div><div>{sorting_query === "date_and_time" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-date_and_time")}></FaSortUp> : 
                                    sorting_query === "-date_and_time" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("date_and_time")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>

                            <TableCell align="center" width="15%">
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center"}}>
                                    <div onClick={() => {toggleSort("content_type")}} style={{ paddingTop: '20px', paddingBottom: '20px'}}>Content Type</div><div>{sorting_query === "content_type" ? 
                                    <FaSortUp size={20} style={{ marginTop: "5px"}} onClick={() => changeSort("-content_type")}></FaSortUp> : 
                                    sorting_query === "-content_type" ? <FaSortDown size={20} style={{ marginTop: "5px"}} onClick={() => {changeSort("content_type")}}></FaSortDown> : 
                                    <div></div>}</div>
                                </div>
                            </TableCell>
                        </TableRow>

                    </TableHead>

                    <TableBody>
                        {
                            getList().map((r) => {
                                return (
                                    <TableRow
                                        // style={r.status === "C" ? completeBorderStyle : incompleteBorderStyle}
                                        key={r.id} onClick={() => onRowClick(r)}
                                    >
                                        <TableCell align="center" width="15%">
                                            {r.username}
                                        </TableCell>
                                        <TableCell align="center" width="15%">
                                            {r.method}
                                        </TableCell>
                                        <TableCell align="center" width="30%">
                                            {new Date(r.date_and_time).toLocaleString()}
                                        </TableCell>
                                        <TableCell align="center" width="40%">
                                            {r.content_type}
                                        </TableCell>

                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {currentListSize.current < offset ? <div></div> : <div className='centered-container'>
                <Button onClick={fetchData}>
                            LOAD MORE!
                </Button>
            </div>}
        </div >
    )
}
